import React from "react";
import { useTranslation } from "react-i18next";
import InfoBottomSheet from "@shared/infoBottomSheet";
import MessageViewer from "@shared/messageViewer";
import { useSelector } from "react-redux";
import { Stack } from "@mui/material";
import { PAN_STATUS_VARIANTS } from "constants/panStatusVariants";

interface IMessageType {
  color: "success" | "error";
  formMessage: string;
  mainMessage: string;
  title: string;
  detailMessage: string;
}
interface IMessage {
  PAN_VERIFIED: IMessageType;
  PAN_INACTIVE: IMessageType;
  PAN_INOPERATIVE: IMessageType;
}

function PanInfoContainer() {
  const { t } = useTranslation();
  const panValidation = useSelector((state: any) => state.pan) as {
    panStatus: keyof IMessage;
    panResponse?: {
      fullName: string;
    };
  };

  const messages: IMessage = {
    PAN_VERIFIED: {
      color: "success",
      formMessage: t("pan_valid", {
        defaultValue: "This PAN is valid.",
      }),
      mainMessage: t("pan_available_message", {
        defaultValue:
          "TDS will be deducted on payouts as per tax regulations.",
      }),
      title: t("ten_percent_tax_message", {
        defaultValue: "Why is TDS being deducted?",
      }),
      detailMessage: t("ten_percent_tax_details_message", {
        defaultValue:
          "Any taxes or levies or the like, as specified under applicable laws will be deducted/collected from the reward amount. TDS deducted & TCS collected if any, will reflect in Form 26AS of the recipient, if valid PAN is shared with Bayer.",
      }),
    },
    PAN_INACTIVE: {
      color: "error",
      formMessage: t("pan_inactive", {
        defaultValue: "This Pan is currently Inactive.",
      }),
      mainMessage: t("itr_not_filed_message", {
        defaultValue:
          "A 20% TDS may apply to your payouts as your PAN is not active.",
      }),
      title: t("twenty_percent_tax_question", {
        defaultValue: "Why is 20% TDS being deducted?",
      }),
      detailMessage: t("pan_not_compliant_message", {
        defaultValue:
          "If your PAN is non-compliant or inoperative (e.g., ITR filings not completed for the last 2 years, PAN is not linked to Aadhaar), a 20% TDS will be deducted as per India’s 194R tax guidelines.",
      }),
    },
    PAN_INOPERATIVE: {
      color: "error",
      formMessage: t("pan_inoperative", {
        defaultValue: "This Pan is currently inoperative.",
      }),
      mainMessage: t("pan_inoperative_message", {
        defaultValue:
          "A 20% TDS may apply to your payouts as your PAN is not active.",
      }),
      title: t("twenty_percent_tax_question", {
        defaultValue: "Why is 20% TDS being deducted?",
      }),
      detailMessage: t("pan_inoperative_details_message", {
        defaultValue:
          "If your PAN is non-compliant or inoperative (e.g., ITR filings not completed for the last 2 years, PAN is not linked to Aadhaar), a 20% TDS will be deducted as per India’s 194R tax guidelines.",
      }),
    },
  };

  const message = () => {
    return messages[panValidation?.panStatus];
  };

  return (
    <>
      {(panValidation?.panStatus === PAN_STATUS_VARIANTS.PAN_VERIFIED ||
        panValidation?.panStatus === PAN_STATUS_VARIANTS.PAN_INACTIVE ||
        panValidation?.panStatus === PAN_STATUS_VARIANTS.PAN_INOPERATIVE) && (
        <Stack rowGap={1}>
          <MessageViewer
            status={message().color}
            details={message().formMessage}
            extraDetails={panValidation?.panResponse?.fullName}
          />
          <InfoBottomSheet
            mainMessage={message().mainMessage}
            title={message().title}
            detailMessage={message().detailMessage}
          />
        </Stack>
      )}
    </>
  );
}

export default PanInfoContainer;
